app.service("shopsMap", function(loading, console) {
	var $self;
	var map;
	var markers = [];

	function init() {
		setElements();
		setEvents();
		initMap();
	}
	function setElements() {
		$self = $("#shops-map");
		$mapContent = $("#map-canvas", $self);
	}
	function setEvents() {
		
	}
	function initMap() {
		$(window).on('orientationchange load', function( event ) {
			resize();
		});
		map = new google.maps.Map($mapContent.get(0), {
			zoom: 6,
			center:{lng: 19.134, lat:51.918}, 
			streetViewControl: false,
			mapTypeControl: false
		});
	}
	var locations;
	var infowindows = [];
	var bounds;
	function setLocations(html){
		locations = [];
		$('<div>'+html+'</div>').find('li').each(function() {
			locations.push({
				name:$(this).data('name'),
				latitude: $(this).data('latitude'),
				longitude: $(this).data('longitude'),
				html: $(this).html()
			});
		});
	}
	function clearMarkers(){
		for (var i = 0; i < markers.length; i++) {
			markers[i].setMap(null);
		}
	}
	function attachSecretMessage(marker, num) {
		infowindows.push(new google.maps.InfoWindow({
			content: locations[num].html
		}));
		google.maps.event.addListener(marker, 'click', function() {
			$.each(infowindows, function(){
				$(this)[0].close();
			});
			infowindows[num].open(marker.get('map'), marker);
			//$mapContent.parent('div').addClass('map-info');
			setTimeout(function() {
				/*
				$mapContent.unbind('click');
				$mapContent.on("click", function() {
					$(this).toggleClass('more');
					map.setCenter(marker.getPosition());
					if($(this).hasClass('more')) {
						var move = $(this).find('.moreInfo').outerHeight();
						map.panBy(0, -move);
					}
				});
				 */
				infowindows[num].setContent(locations[num].html);
			}, 200);
		});
	}
	function setBoundsAndMarkers(){
		bounds = new google.maps.LatLngBounds();
		$(locations).each(function(i,shop){
			var latlng = new google.maps.LatLng(shop.latitude, shop.longitude);
			bounds.extend(latlng);
			var marker = new google.maps.Marker({
				position: latlng,
				map: map
			});
			attachSecretMessage(marker, i);
			markers.push(marker);
		});
	}
	function resize(){
		$mapContent.height($(window).height()/2);
	}
	function update(html) {
		resize();
		bounds = new google.maps.LatLngBounds();
		infowindows = [];
		setLocations(html);
		clearMarkers();
		setBoundsAndMarkers();
		
		google.maps.event.trigger(map, "resize");
		map.setCenter(bounds.getCenter());
		if(locations.length > 1) {
			map.fitBounds(bounds);
		} else {
			map.setZoom(10);
		}
	}
	
	return {
		init: init,
		update: update
	};
});